import { HeadingText } from '@/components/atoms/HeadingText';
import { useFormContext } from '@/components/forms/FormContext';
import { type ReplaceInPersonFormState, StepMap, steps } from '../../constants';
import { isValid } from './state';
import { Step } from '@/components/forms/Step';
import { handleNext } from './routing';
import { useValidateStep } from '@/components/forms/useValidateStep';
import { ReplaceInPersonFormActionMap } from '../../reducer';
import { TextAlert } from '@/components/calculators/TextAlert';
import { IconInfoBubble } from '@/components/icons';
import { WizardBoxRadio } from '@/components/WizardBox/WizardBoxRadio';

export interface SystemAgeStepProps {
	testId?: string;
}

const SystemAgeStep = (props: SystemAgeStepProps) => {
	const { testId = 'SystemAgeStep' } = props;
	const { state, dispatch } = useFormContext<
		StepMap,
		ReplaceInPersonFormState,
		ReplaceInPersonFormActionMap
	>();
	useValidateStep<
		StepMap,
		ReplaceInPersonFormState,
		ReplaceInPersonFormActionMap
	>(isValid, steps.SystemAge);

	function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
		dispatch({ type: 'UPDATE_SYSTEM_AGE', payload: event.target.value });
	}

	return (
		<div data-testid={testId}>
			<Step<StepMap, ReplaceInPersonFormState, ReplaceInPersonFormActionMap>
				name={steps.SystemAge}
				onNext={handleNext}
			>
				<HeadingText
					tag="h1"
					size="h2"
					className="mb-10 mt-10 lg:mb-14 lg:mt-20"
					balanced
				>
					What is the approximate age of your system?
				</HeadingText>

				<div className="mx-auto mb-8 grid max-w-screen-lg grid-cols-2 gap-4 lg:mb-10 lg:grid-cols-6 lg:gap-6">
					<WizardBoxRadio
						label="0-5"
						description="years"
						name="systemAge"
						id="0-5-years"
						value="0-5 years"
						onChange={handleChange}
						checked={state.systemAge.includes('0-5')}
					/>
					<WizardBoxRadio
						label="6-10"
						description="years"
						name="systemAge"
						id="6-10-years"
						value="6-10 years"
						onChange={handleChange}
						checked={state.systemAge.includes('6-10')}
					/>
					<WizardBoxRadio
						label="11-15"
						description="years"
						name="systemAge"
						id="11-15-years"
						value="11-15 years"
						onChange={handleChange}
						checked={state.systemAge.includes('11-15')}
					/>
					<WizardBoxRadio
						label="16-20"
						description="years"
						name="systemAge"
						id="16-20-years"
						value="16-20 years"
						onChange={handleChange}
						checked={state.systemAge.includes('16-20')}
					/>
					<WizardBoxRadio
						label="21+"
						description="years"
						name="systemAge"
						id="21+-years"
						value="21+ years"
						onChange={handleChange}
						checked={state.systemAge.includes('21+')}
					/>
					<WizardBoxRadio
						label="?"
						description="not sure"
						name="systemAge"
						id="not-sure"
						value="Not sure"
						onChange={handleChange}
						checked={state.systemAge.includes('Not sure')}
					/>
				</div>
				<TextAlert
					renderIcon={IconInfoBubble}
					title="Why are we asking?"
					text="The age of your system helps us find the best HVAC expert based on your system’s warranties, condition, and efficiency."
				/>
			</Step>
		</div>
	);
};

export default SystemAgeStep;
